<div class="lcl-booking-header-route" *ngIf="isManagementView">
  <app-lcl-header-detailed-info
    [isQuote]="true"
    [isHideEditIncoterms]="true"
    [info]="booking"
    [referenceValue]="booking.referenceNumber"
    [referenceName]="'LABELS.QUOTE_ID'"
  ></app-lcl-header-detailed-info>
</div>

<div class="lcl-booking-header-mobile">
  <div class="lcl-booking-header-mobile-card">
    <div class="lcl-booking-header-mobile-icon">
      <img src="assets/icons/icon_vessel_dark.svg" />
    </div>
    <div class="lcl-booking-header-mobile-route">
      <div class="route-item">
        <div class="circle"></div>
        <div class="departure-line"></div>
        <span>
          <p>{{ "LABELS.FROM" | translate }}</p>
          <strong>{{ booking?.voyage?.route?.departurePort?.displayName }}</strong>
          ({{ booking?.voyage?.route?.departurePort?.unCode }}), {{ booking?.voyage?.route?.departurePort?.country?.description }}
        </span>
      </div>
      <div class="route-item">
        <div class="circle"></div>
        <div class="arrival-line"></div>
        <span>
          <p>{{ "LABELS.TO" | translate }}</p>
          <strong>{{ booking?.voyage?.route?.arrivalPort?.displayName }}</strong>
          ({{ booking?.voyage?.route?.arrivalPort?.unCode }}), {{ booking?.voyage?.route?.arrivalPort?.country?.description }}
        </span>
      </div>
    </div>
  </div>
</div>

<div class="lcl-booking-container">
  <div class="scrollable-wrapper">
    <div class="fix-scroll">
      <div class="lcl-booking-payment-mobile">
        <app-lcl-payment-card
          [isMobileView]="true"
          [isCollapsed]="true"
          [pendingBills]="pendingBills?.items"
          [pendingMarineInsuranceBills]="pendingMarineInsuranceBills"
          [productsByCompany]="productsByCompany"
          [isHasISF]="formGroup.get('isfRequested').value"
          [isHasES]="formGroup.get('entrySummaryRequested').value"
          [isHasExportLicense]="formGroup.get('exportLicenseRequested').value"
          [isBooking]="true"
          [isBillLoading]="isBillLoading"
        ></app-lcl-payment-card>
      </div>

      <div class="container lcl-booking-wrapper">
        <div class="d-lg-none">
          <div class="payment-breakdown-warning">
            <span>{{ "LABELS.LEGAL_TERMS_DISCLAIMER_FOURTH_OPTION" | translate }}</span>
          </div>

          <div class="payment-breakdown-hint-secondary">
            <span>{{ "LABELS.QUOTE_LCL_HINT_SECONDARY" | translate }}</span>
          </div>
        </div>

        <header>
          <h2>{{ "LABELS.CONFIRM_REMAINING_DETAILS_PLACE_ORDER" | translate }}</h2>
          <p>{{ "LABELS.OVERVIEW_YOUR_SHIPMENT_LINE_1" | translate }}</p>
          <p>{{ "LABELS.OVERVIEW_YOUR_SHIPMENT_LINE_2" | translate }}</p>
        </header>

        <div class="lcl-booking-card">
          <section class="lcl-booking-card-body">
            <div class="row">
              <div class="col-12 col-lg-4 order-lg-1 d-none d-lg-block">
                <app-lcl-payment-card
                  [pendingBills]="pendingBills?.items"
                  [pendingMarineInsuranceBills]="pendingMarineInsuranceBills"
                  [productsByCompany]="productsByCompany"
                  [isHasISF]="formGroup.get('isfRequested').value"
                  [isHasES]="formGroup.get('entrySummaryRequested').value"
                  [isHasExportLicense]="formGroup.get('exportLicenseRequested').value"
                  [isBooking]="true"
                  [isBillLoading]="isBillLoading"
                ></app-lcl-payment-card>
              </div>

              <div class="col-12 col-lg-8 order-lg-0">
                <ng-container *ngIf="!isManagementView">
                  <div class="lcl-booking-card-body-packages">
                    <app-lcl-create-quote-packages
                      [packagesFormArray]="packagesFormArray"
                      [isMobile]="!isDesktop"
                      [isSidebar]="isDesktop"
                      [isLoading]="recalcFormLoading"
                      [isQuoteEdit]="true"
                      [isBookingEdit]="true"
                      [isInCard]="false"
                      (addPackage)="isDesktop ? addPackage() : addMobilePackage()"
                      (editPackage)="editPackage($event)"
                      (confirmPackage)="confirmPackage()"
                      (removePackage)="onRemovePackage($event)"
                    ></app-lcl-create-quote-packages>
                  </div>
                </ng-container>

                <ng-container *ngIf="isManagementView">
                  <app-lcl-packages-view
                    [packages]="booking.packages"
                    [isEditablePackages]="!isManagementView"
                    (removePackage)="onRemovePackage($event)"
                    (savePackages)="onSavePackages($event)"
                  ></app-lcl-packages-view>
                </ng-container>

                <div class="d-lg-none" *ngIf="!isDesktop">
                  <lcl-incoterms
                    [incoterms]="booking?.incoTermsType"
                    [companyShippingRole]="booking?.shippingRole"
                    (changeIncotermsSource)="setIncoterms($event)"
                    (changeShippingRole)="setShippingRole($event)"
                  ></lcl-incoterms>
                </div>

                <app-lcl-card cardTitle="LABELS.VOYAGE_DETAILS">
                  <ng-container body>
                    <p class="text-change-voyage">{{ "LABELS.CONFIRM_VOYAGE_DETAILS" | translate }}</p>

                    <app-lcl-select-voyage
                      *ngFor="let voyage of voyages"
                      [voyage]="voyage"
                      [voyageIdControl]="voyageIdControl"
                      [isVoyageChanged]="voyageIdControl.value !== initialVoyageId"
                    ></app-lcl-select-voyage>
                  </ng-container>

                  <ng-container footer>
                    <p class="text-change-voyage-hint">
                      <span>{{ "LABELS.CONFIRM_VOYAGE_DETAILS_HINT" | translate }}</span>
                    </p>
                  </ng-container>
                </app-lcl-card>

                <desktop-entity-card
                  [entity]="buyerEntity"
                  [entityCode]="enumEntityModelCode.BUYER"
                  [descEntityOverride]="ENTITY_INFO_DESC"
                  [isDisabledParent]="true"
                  [isShowIdentifier]="false"
                  [isShowAddIcons]="true"
                  [isHiddenButtons]="true"
                  [isSkipAddIcon]="true"
                  [isShowValidIcon]="false"
                  [isShowEntityRequired]="!isEntityValid(buyerEntity) && isShowError"
                  [isShowEmail]="true"
                  [isShowPhone]="true"
                  [isHideShowEdit]="!!buyerEntity && !!incotermsHeaderLabel && isShowChangeRole(enumEntityModelCode.CONSIGNEE)"
                  [sameAs]="entitySameAsCompany(buyerEntity)"
                  (useDifferent)="onEditEntity(buyerEntity, enumEntityModelCode.CONSIGNEE, true)"
                  (edit)="onEditEntity(buyerEntity, enumEntityModelCode.CONSIGNEE)"
                >
                  <ng-container entity-header-action>
                    <div
                      class="change-shipping-role-link d-none d-lg-block"
                      *ngIf="!!incotermsHeaderLabel && isShowChangeRole(enumEntityModelCode.CONSIGNEE)"
                      (click)="updateShippingRole(buyerEntity, enumEntityModelCode.CONSIGNEE)"
                    >
                      <span>{{ incotermsHeaderLabel | translate }}</span>
                      <img src="assets/icons/icon_chevron_up.svg" />
                    </div>
                  </ng-container>

                  <ng-container entity-footer>
                    <div
                      class="change-shipping-role-link change-shipping-role-link-footer d-lg-none"
                      *ngIf="!!incotermsHeaderLabel && isShowChangeRole(enumEntityModelCode.CONSIGNEE)"
                      (click)="updateShippingRole(buyerEntity, enumEntityModelCode.CONSIGNEE)"
                    >
                      <span>{{ incotermsHeaderLabel | translate }}</span>
                      <img src="assets/icons/icon_chevron_up.svg" />
                    </div>
                  </ng-container>
                </desktop-entity-card>

                <desktop-entity-card
                  [entity]="sellerEntity"
                  [entityCode]="enumEntityModelCode.SHIPPER"
                  [descEntityOverride]="ENTITY_INFO_DESC"
                  [isDisabledParent]="true"
                  [isShowIdentifier]="false"
                  [isShowAddIcons]="true"
                  [isHiddenButtons]="true"
                  [isSkipAddIcon]="true"
                  [isShowValidIcon]="false"
                  [isShowEntityRequired]="!isEntityValid(sellerEntity) && isShowError"
                  [isShowEmail]="true"
                  [isShowPhone]="true"
                  [isHideShowEdit]="!!sellerEntity && !!incotermsHeaderLabel && isShowChangeRole(enumEntityModelCode.SHIPPER)"
                  [sameAs]="entitySameAsCompany(sellerEntity)"
                  (useDifferent)="onEditEntity(sellerEntity, enumEntityModelCode.SHIPPER, true)"
                  (edit)="onEditEntity(sellerEntity, enumEntityModelCode.SHIPPER)"
                >
                  <ng-container entity-header-action>
                    <div
                      class="change-shipping-role-link d-none d-lg-block"
                      *ngIf="!!incotermsHeaderLabel && isShowChangeRole(enumEntityModelCode.SHIPPER)"
                      (click)="updateShippingRole(sellerEntity, enumEntityModelCode.SHIPPER)"
                    >
                      <span>{{ incotermsHeaderLabel | translate }}</span>
                      <img src="assets/icons/icon_chevron_up.svg" />
                    </div>
                  </ng-container>

                  <ng-container entity-footer>
                    <div
                      class="change-shipping-role-link change-shipping-role-link-footer d-lg-none"
                      *ngIf="!!incotermsHeaderLabel && isShowChangeRole(enumEntityModelCode.SHIPPER)"
                      (click)="updateShippingRole(sellerEntity, enumEntityModelCode.SHIPPER)"
                    >
                      <span>{{ incotermsHeaderLabel | translate }}</span>
                      <img src="assets/icons/icon_chevron_up.svg" />
                    </div>
                  </ng-container>
                </desktop-entity-card>

                <desktop-entity-card
                  [entity]="notifyPartyEntity"
                  [entityCode]="enumEntityModelCode.NOTIFY_PARTY"
                  [descEntityOverride]="ENTITY_INFO_DESC"
                  [isDisabledParent]="true"
                  [isShowIdentifier]="false"
                  [isShowAddIcons]="true"
                  [isHiddenButtons]="true"
                  [isSkipAddIcon]="true"
                  [isShowValidIcon]="false"
                  [isShowEmail]="true"
                  [isShowPhone]="true"
                  (useDifferent)="onEditEntity(notifyPartyEntity, enumEntityModelCode.NOTIFY_PARTY, true)"
                  (edit)="onEditEntity(notifyPartyEntity, enumEntityModelCode.NOTIFY_PARTY)"
                ></desktop-entity-card>

                <app-lcl-edit-additional-options
                  [formGroup]="formGroup"
                  [quote]="booking"
                  [isManagementView]="isManagementView"
                  [quoteCompany]="company"
                  [isInsuranceAvailable]="isInsuranceAvailable"
                  [isInsuranceLoading]="isInsuranceLoading"
                  [currentInsurance]="currentInsurance"
                  [marineInsuranceRequested]="marineInsuranceRequested"
                  [isVoyageValidForInsurance]="isVoyageValidForInsurance"
                  (optionISFUpdated)="onOptionISFUpdated($event)"
                  (optionESUpdated)="onOptionESUpdated($event)"
                  (optionExportLicenseUpdated)="onOptionExportLicenseUpdated($event)"
                  (optionMarineInsuranceUpdated)="onOptionMarineInsuranceUpdated($event)"
                ></app-lcl-edit-additional-options>

                <app-lcl-hazard-disclaimer [formGroup]="formGroup"></app-lcl-hazard-disclaimer>

                <app-lcl-card cardTitle="LABELS.TERMS">
                  <ng-container body>
                    <div class="d-flex flex-column">
                      <div class="legal-terms-disclaimer">
                        <span class="legal-terms-disclaimer__text">
                          {{ "LABELS.LEGAL_TERMS_DISCLAIMER_PREFIX" | translate }}
                        </span>
                        <span>
                          <a class="legal-terms-disclaimer__link" [routerLink]="['/legal-terms']">
                            {{ "LABELS.LEGAL_TERMS_DISCLAIMER_LINK" | translate }}
                          </a>
                        </span>
                      </div>
                      <ul class="legal-terms-disclaimer__options">
                        <li>
                          {{ "LABELS.LEGAL_TERMS_DISCLAIMER_FIRST_OPTION" | translate }}
                        </li>
                        <li>
                          {{ "LABELS.LEGAL_TERMS_DISCLAIMER_SECOND_OPTION" | translate }}
                        </li>
                        <li>
                          {{ "LABELS.LEGAL_TERMS_DISCLAIMER_THIRD_OPTION" | translate }}
                        </li>
                        <li>
                          {{ "LABELS.LEGAL_TERMS_DISCLAIMER_FOURTH_OPTION" | translate }}
                        </li>
                        <li>
                          {{ "LABELS.LEGAL_TERMS_DISCLAIMER_FIFTH_OPTION" | translate }}
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </app-lcl-card>

                <div *ngIf="isShowError && isSubmitted" class="booking-error">
                  <span class="booking-error__header">{{ "LCL_SHIPMENT.BOOKING.MISSING_DETAILS" | translate }}</span>
                  <span class="booking-error__description">{{ "LCL_SHIPMENT.BOOKING.MISSING_FIELDS_WARNING" | translate }}</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <app-lcl-footer [isFixed]="true" *ngIf="!isManagementView">
    <ng-container footer>
      <button class="btn btn-primary" (click)="onSubmit()">
        {{ "BUTTON.PLACE_ORDER" | translate }}
      </button>
    </ng-container>
  </app-lcl-footer>
</div>

<custom-modal [header]="'LABELS.NOTE'" [open]="isShowMonsoonAlert" (openChange)="onMonsoonAlertChange($event)">
  <strong>{{ "MONSOON_SEASON_ALERT" | translate }}</strong>

  <p>{{ "MONSOON_SEASON_ALERT_TEXT" | translate }}</p>

  <button footer-action class="btn btn-primary" type="button" (click)="onMonsoonAlertChange(false)">
    {{ "BUTTON.CLOSE" | translate }}
  </button>
</custom-modal>
